module.exports = __webpack_public_path__ + "static/scale-model-of-raez-photography-in-worcester-massachusetts-921d3a77e7c471c76a78bc807e42a262.png";